import BlogArticleQ from '@/queries/BlogArticleQ'
import { useQuery } from '@/client/context/query'
import { SQL } from '@/client/query'
import type {
  BlogArticleCategory,
  BlogArticleDetails,
  BlogArticlePinnedTo,
} from '@/client/services/blog'

import { blogArticleDetailsFromQuery } from '@/components/Worlds/transforms/detailsFromQueries'

export default function useBlogArticles({
  category,
  pinnedTo,
  limit,
  offset,
}: {
  category?: BlogArticleCategory
  pinnedTo?: BlogArticlePinnedTo
  limit?: number | null
  offset?: number | null
} = {}): { blogArticles: BlogArticleDetails[]; countTotalItems: number } {
  const query = useQuery()

  const blogArticles = query.many`
      ${BlogArticleQ.where(
        {
          category,
          pinnedTo,
          order: [
            [BlogArticleQ.published_at, 'desc'],
            [BlogArticleQ.created_at, 'desc'],
          ],
        },
        BlogArticleQ.isPublished()
      )}
      ${limit == null ? SQL`` : SQL`LIMIT ${limit}`}
      ${offset == null ? SQL`` : SQL`OFFSET ${offset}`}
  `.map(blogArticleDetailsFromQuery)

  const countTotalItems =
    query<number>`COUNT(*) ${BlogArticleQ.where(
      {
        category,
        pinnedTo,
      },
      BlogArticleQ.isPublished()
    )}` ?? 0

  return { blogArticles, countTotalItems }
}
